import corn from '../images/allergens/corn.png';
import crustean from '../images/allergens/crustean.png';
import egg from '../images/allergens/egg.png';
import fish from '../images/allergens/fish.png';
import gluten from '../images/allergens/gluten.png';
import lactose from '../images/allergens/lactose.png';
import LU from '../images/allergens/LU.png';
import mustard from '../images/allergens/mustard.png';
import nut from '../images/allergens/nut.png';
import peanut from '../images/allergens/peanut.png';
import SE from '../images/allergens/SE.png';
import SO from '../images/allergens/SO.png';
interface Allergen {
  key: string;
  description: string;
  icon: any;
}

interface Additive {
  key: string;
  description: string;
}

export const allergens: Allergen[] = [
  {
    key: 'A',
    description: 'Gluten',
    icon: gluten,
  },
  {
    key: 'B',
    description: 'Krebstiere',
    icon: crustean,
  },
  {
    key: 'C',
    description: 'Eier',
    icon: egg,
  },
  {
    key: 'D',
    description: 'Fische',
    icon: fish,
  },
  {
    key: 'E',
    description: 'Erdnüsse',
    icon: peanut,
  },
  {
    key: 'F',
    description: 'Soja',
    icon: SO,
  },
  {
    key: 'G',
    description: 'Milch',
    icon: lactose,
  },
  {
    key: 'H',
    description: 'Schalenfrüchte',
    icon: nut,
  },
  {
    key: 'I',
    description: 'Sellerie',
    icon: SE,
  },
  {
    key: 'J',
    description: 'Senf',
    icon: mustard,
  },
  {
    key: 'K',
    description: 'Sesamsamen',
    icon: SE,
  },
  {
    key: 'L',
    description: 'Schwefeldioxid',
    icon: SO,
  },
  {
    key: 'M',
    description: 'Lupinen',
    icon: LU,
  },
  {
    key: 'N',
    description: 'Weichtiere',
    icon: corn,
  },
];

export const additives: Additive[] = [
  {
    key: '1',
    description: 'mit Farbstoff',
  },
  {
    key: '2',
    description: 'mit Konservierungsstoff',
  },
  {
    key: '3',
    description: 'mit Antioxidationsmittel',
  },
  {
    key: '4',
    description: 'mit Geschmacksverstärker',
  },
  {
    key: '5',
    description: 'geschwefelt',
  },
  {
    key: '6',
    description: 'geschwärzt',
  },
  {
    key: '7',
    description: 'mit Phosphat',
  },
  {
    key: '8',
    description: 'mit Milcheiweiß (bei Fleischerzeugnissen)',
  },
  {
    key: '9',
    description: 'koffeinhaltig',
  },
  {
    key: '10',
    description: 'chininhaltig',
  },
  {
    key: '11',
    description: 'mit Süßungsmitteln',
  },
  {
    key: '12',
    description: 'enthält eine Phenylalaninquelle',
  },
  {
    key: '13',
    description: 'gewachst',
  },
  {
    key: '14',
    description: 'unter Schutzatmosphäre verpackt',
  },
];

export const allergensAndAdditives: (Allergen | Additive)[] = [
  ...allergens,
  ...additives,
];

export const getAllergens = (active?: string): Allergen[] => {
  if (active) {
    return allergens.filter((allergen) => active.includes(allergen.key));
  }

  return allergens;
};

export const getAllergensAndAdditives = (
  active?: string,
): (Allergen | Additive)[] => {
  if (active) {
    return allergensAndAdditives.filter((item) => active.includes(item.key));
  }

  return allergensAndAdditives;
};
